import React, { useEffect } from "react";
import UI from "@mile-meeting/mile-ui";
import {
  ComboboxContainer,
  Container,
  TextFieldContainer,
  DropdownContainer,
  DropdownItemContainer,
} from "./MeetingRoomFilter.styles";

type MeetingRoomFilterProps = {
  onChange?: (value?: string) => void;
  meetingRoomList?: string[];
  selectedRoom?: string;
};
const MeetingRoomFilter: React.FC<MeetingRoomFilterProps> = ({ onChange, selectedRoom, meetingRoomList }) => {
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const [openMeetingRoomDropdown, setOpenMeetingRoomDropdown] = React.useState<boolean>(false);
  const ref = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (event: any) => {
      if (openMeetingRoomDropdown && ref.current && !ref.current.contains(event.target)) {
        setOpenMeetingRoomDropdown?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [openMeetingRoomDropdown]);

  return (
    <Container onFocus={() => setOpenMeetingRoomDropdown(true)}>
      <UI.InputGroup.TextField
        width={200}
        prefixIcon="meetingRoom2"
        showPrefixIcon
        placeholder="회의실 선택"
        size="small"
        value={selectedRoom ? selectedRoom : ""}
        disabledFocus
        suffixIcon="removeCircle"
      />
      {openMeetingRoomDropdown && (
        <ComboboxContainer ref={ref}>
          <TextFieldContainer>
            <UI.Input
              placeholder="회의실 검색"
              size="small"
              width={"188px"}
              onChange={(value) => {
                setSearchQuery(value);
              }}
            />
          </TextFieldContainer>
          <DropdownContainer>
            <DropdownItemContainer
              onClick={() => {
                onChange?.(undefined);
                setOpenMeetingRoomDropdown(false);
              }}
            >
              <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-alternative)">
                전체 회의실
              </UI.Typography>
            </DropdownItemContainer>
            {(meetingRoomList ?? [])
              .filter((item) => item.includes(searchQuery))
              .map((room) => (
                <DropdownItemContainer
                  key={room}
                  onClick={() => {
                    onChange?.(room);
                    setOpenMeetingRoomDropdown(false);
                  }}
                >
                  <UI.Typography
                    type="label01"
                    fontStyle={selectedRoom === room ? "bold" : "regular"}
                    color="var(--alias-color-label-normal)"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: 162,
                    }}
                  >
                    {room}
                  </UI.Typography>
                </DropdownItemContainer>
              ))}
          </DropdownContainer>
        </ComboboxContainer>
      )}
    </Container>
  );
};

export default React.memo(MeetingRoomFilter);
